//router
import { createRouter, createWebHistory } from "vue-router";
import store from '../store'
import axios from "axios";
import { confirmLeaveAgentStream } from '../utils/agentStreamGuard';

//Main Sections
import Portal from '../views/Portal'
import Login from '../views/Login'
import CidLogin from '../views/CidLogin'
import Logout from '../views/Logout'
import Onboarding from "../views/Onboarding.vue";
import Dashboard from '../views/Dashboard'
import ChangeLog from '../views/ChangeLog'
import ClientCheckList from "../views/ClientCheckList.vue";

//Admin Section
import Users from '../views/admin/Users'
import User from '../views/admin/User'
import Clients from '../views/admin/Clients'
import Client from '../views/admin/Client'
import Usage from '../views/admin/Usage'
import UsageTest from '../views/admin/UsageTest'
import UsageDemo from '../views/admin/UsageDemo'
import InfrastructureUsage from '../views/admin/InfrastructureUsage'
import Reports from '../views/admin/reports/Reports'
import SignIns from "../views/admin/reports/SignIns.vue";
import AdminDashboards from '../views/admin/Dashboards'
import Tokens from '../views/admin/Tokens';
import Token from '../views/admin/Token';
import EncryptedURLs from '../views/admin/EncryptedURLs';
import EncryptedURL from '../views/admin/EncryptedURL';
import Products from '../views/admin/Products';
import Product from '../views/admin/Product';
import Entitlements from '../views/admin/Entitlements';
import Entitlement from '../views/admin/Entitlement';
import JobTemplate from '../views/admin/JobTemplate';
import JobTemplates from '../views/admin/JobTemplates';
import JobTemplateDetails from '../views/admin/JobTemplateDetails';
import JobStacks from '../views/admin/JobStacks';
import JobStack from '../views/admin/JobStack';
import AddJobStack from "../views/admin/AddJobStack.vue";
import AquacredCredentials from '../views/admin/AquacredCredentials';
import AquacredCredential from '../views/admin/AquacredCredential';
import DocLinks from '../views/admin/DocLinks'
import DocLink from '../views/admin/DocLink'
import AiUsage from '../views/admin/AiUsage'
import AiUsageAgents from '../views/admin/AiUsageAgents'
import AiUsageMcp from '../views/admin/AiUsageMcp'

//aUT
import GeneralSettings from '../views/aut/Settings'
import Classes from '../views/aut/Classes'
import CertificateDatails from '../views/aut/CertificateDetails.vue'
import Certificates from '../views/aut/Certificates'
import Certificate from '../views/aut/Certificate'
import TagTemplates from '../views/aut/TagTemplates'
import TagTemplate from '../views/aut/TagTemplate'
import PublicTagTemplates from '../views/aut/PublicTagTemplates'
import PublicTagTemplate from '../views/aut/PublicTagTemplate'
import InitiatorFields from '../views/aut/InitiatorFields'
import InitiatorField from '../views/aut/InitiatorField'
import GenerateTag from '../views/aut/GenerateTag'
import ConfigureHosts from '../views/aut/ConfigureHosts'
import ConfigureCnames from '../views/aut/ConfigureCNames'
import AutReports from '../views/aut/Reports'
import AutDashboards from '../views/aut/Dashboards'
import Initiators from '../views/aut/Initiators'
import Initiator from '../views/aut/Initiator'
import ClientInitiators from '../views/aut/ClientInitiators'
import ClientInitiator from '../views/aut/ClientInitiator'
import ClientInitiatorFields from '../views/aut/ClientInitiatorFields'
import ClientInitiatorField from '../views/aut/ClientInitiatorField'
import autUsage from '../views/aut/Usage'
import AutCredentials from '../views/aut/Credentials'

//aMDP
import Queries from '../views/amdp/Queries'
import Query from '../views/amdp/Query'
import Credentials from '../views/amdp/Credentials'
import Credential from '../views/amdp/Credential'
import AnalyticsEngineDemo from "../views/amdp/AnalyticsEngineDemo.vue";
import amdpUsage from '../views/amdp/Usage'
import JobsDashboard from '../views/amdp/JobsDashboard'
import Jobs from '../views/amdp/job-management/Jobs'
import Pipelines from '../views/amdp/job-management/Pipelines'
import JobsTab from '../views/amdp/JobsTab'
import JobDetail from '../views/amdp/JobDetail'
import AdminQueries from '../views/amdp/AdminQueries'
import FileBrowser from '../views/filebrowser/Browser'
import FolderView from '../views/filebrowser/FolderView'
import FileView from '../views/filebrowser/FileView'
import OutputParser from '../components/OutputParser';
import Configurator from '../views/amdp/Configurator';
import ConfiguratorDetails from '../views/amdp/ConfiguratorDetails';
import CidJobTemplateDetails from '../views/amdp/CidJobTemplateDetails';
import CidJobTemplates from '../views/amdp/CidJobTemplates';
import CidJobTemplate from '../views/amdp/CidJobTemplate';
import DataMapper from "../views/amdp/DataMapper.vue";
import DataMapperStreaming from "../views/amdp/DataMapperStreaming.vue";
import DataMapperInvocations from "../views/amdp/DataMapperInvocations.vue";
import TalkToMyData from "../views/amdp/TalkToMyData.vue";
import AllMapMyDataInvocations from "../views/amdp/DataMapperInvocationsAdmin.vue";
import AllMapMyDataSpecificInvocation from "../views/amdp/DataMapperInvocationAdmin.vue";

//Audience Manager
import Audiences from '../views/audience/Audiences'
import AudienceDetail from '../views/audience/AudienceDetail'

//aGM
import agmDashboards from '../views/agm/Dashboards'
import IDRList from '../views/agm/IDRList'
import IDRJobDetail from '../views/agm/IDRJobDetail'
import IDRConfiguration from '../views/agm/job-management/Configuration'
import JobStackDeploymentsList from '../views/agm/JobStackDeploymentsList'
import JobStackDeploymentsDetail from '../views/agm/JobStackDeploymentDetails'
import JobStackDeploymentsDetailEdit from '../views/agm/JobStackDeploymentDetailsEdit'
import JobStackDeploymentsDetailPipeline from '../views/agm/JobStackDeploymentDetailsPipeline'
import JobStackDeploymentsDetailVisualize from '../views/agm/JobStackDeploymentDetailsVisualize'
import GraphReport from '../views/agm/GraphReport'
import GraphReportV2 from '../views/agm/GraphReportV2'
import GraphVisualizer from '../views/agm/GraphVisualizer'
import GraphMyData from '../views/agm/GraphMyData.vue'
import GraphCuration from "../views/agm/GraphCuration.vue";
import ClusterFormation from "../views/agm/ClusterFormation.vue";
//aIO
import aioUsage from '../views/aio/Usage'
import aioDashboards from '../views/aio/Dashboards'
import aioHandlerSandbox from '../views/aio/HandlerSandbox'
import HandlerDetails from '../views/aio/HandlerDetails'
import HandlerConfiguration from '../views/aio/handler-management/Configuration'
import HandlerRequests from '../views/aio/handler-management/Requests'

//Sandbox
import UnitTest from '../views/sandbox/UnitTest'
import UnitTestExecution from '../views/sandbox/UnitTestExecution'
import Management from '../views/sandbox/Management'
import SandboxUserAccess from '../views/sandbox/SandboxUserAccess'
import SandboxDetail from '../views/sandbox/SandboxDetail'
import SandboxJobDetail from '../views/sandbox/SandboxJobDetail'
import SandboxCredentials from '../views/sandbox/SandboxCredentials'
import SandboxCredential from '../views/sandbox/SandboxCredential'

import SandboxJobsTab from '../views/sandbox/SandboxJobsTab'
import SandboxJobs from '../views/sandbox/SandboxJobs'
import SandboxPipelines from '../views/sandbox/SandboxPipelines'
import Configuration from '../views/sandbox/job-management/Configuration'
import RunHistory from '../views/sandbox/job-management/RunHistory'
import ExecutionDetails from '../views/sandbox/job-management/ExecutionDetails'
import SandboxJobPromotions from '../views/sandbox/job-management/Promotions'
import JobOverride from '../views/sandbox/job-management/Override'
import JobMeters from '../views/sandbox/job-management/Meters'
import JobParameters from '../views/sandbox/job-management/Parameters'
import Promotions from '../views/sandbox/Promotions'
import PromotionDetail from '../views/sandbox/PromotionDetail'
import PromotionConfiguration from '../views/sandbox/promotion-management/Configuration'
import PromotionRunHistory from '../views/sandbox/promotion-management/RunHistory' 
import PromotionOverview from '../views/sandbox/promotion-management/Overview'
import DeployJobStack from "../views/admin/DeployJobStack.vue";

//PAICE
import PaiceChat from '../views/paice/Chat'
import PaiceSettings from '../views/paice/Settings'
import PaiceOAuthCallback from '../views/paice/OAuthCallback'
import SessionRefreshCallback from '../views/SessionRefreshCallback'

//Apps
import ClientApp from '../views/ClientApp.vue'

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/:cid/login',
        name: 'CidLogin',
        component: CidLogin
    },
    {
        path: '/logout',
        name: 'Logout',
        component: Logout
    },
    {
        // Redirect URI for connecting an external MCP server over OAuth. Must
        // match `mcpOauthRedirectUri` in the agents stack byte for byte —
        // authorization servers compare it exactly, and it is published in our
        // CIMD document.
        //
        // Top-level rather than under the Portal shell: it renders inside a
        // 680px consent popup for a fraction of a second, hands the query
        // parameters to the window that opened it, and closes. Drawing the
        // portal chrome (and its cid resolution) around that would be all cost.
        path: '/paice/oauth/callback',
        name: 'PAICE OAuth Callback',
        component: PaiceOAuthCallback
    },
    {
        // success_redirect_url for the session-refresh popup (utils/sessionRefreshPopup.js).
        // Public and outside the Portal shell for the same reasons as the PAICE callback.
        path: '/auth/session-callback',
        name: 'Session Refresh Callback',
        component: SessionRefreshCallback
    },
    {
        path: '/onboarding',
        name: 'Onboarding',
        component: Onboarding
    },
    {
        path: '',
        component: Portal,
        children: [
            {
                path: '',
                name: 'Home',
                component: Dashboard
            },
            {
                path: '/changelog',
                name: 'ChangeLog',
                component: ChangeLog
            },
            {
                path: '/check-list',
                name: 'Client Check List',
                component: ClientCheckList
            },
            {
                path: '/admin/users',
                name: 'Users',
                component: Users
            },
            {
                path: '/admin/users/:id',
                name: 'User',
                component: User
            },
            {
                path: '/admin/clients',
                name: 'Clients',
                component: Clients
            },
            {
                path: '/admin/usage',
                name: 'Entitlement Usage',
                component: Usage
            },
            {
                path: '/admin/usagetest',
                name: 'Entitlement Usage TESTING',
                component: UsageTest
            },
            {
                path: '/admin/usagedemo',
                name: 'Entitlement Usage Mockup',
                component: UsageDemo
            },
            {
                path: '/admin/infrastructure-usage',
                name: 'Infrastructure Usage',
                component: InfrastructureUsage
            },
            {
                path: '/admin/clients/:id',
                alias: [
                    '/admin/clients/:id/subscriptions',
                    '/admin/clients/:id/settingsV2',
                ],
                name: 'Client',
                component: Client
            },
            {
                path: '/admin/reports',
                name: 'Reports',
                component: Reports,
                children: [
                    {
                        path: '/admin/reports/sign-ins',
                        name: 'Sign Ins',
                        component: SignIns
                    },
                ]
            },
            {
                path: '/admin/dashboards',
                name: 'Dashboards',
                component: AdminDashboards
            },
            {
                path: '/admin/tokens',
                name: 'Tokens',
                component: Tokens
            },
            {
                path: '/admin/tokens/:id',
                name: 'Token',
                component: Token,
                meta: {
                    "cidChangeRedirectRoute": "Tokens"
                }
            },
            {
                path: '/admin/encrypted-urls',
                name: 'EncryptedURLs',
                component: EncryptedURLs
            },
            {
                path: '/admin/encrypted-urls/:uuid',
                name: 'EncryptedURL',
                component: EncryptedURL
            },
            {
                path: '/admin/products',
                name: 'Products',
                component: Products
            },
            {
                path: '/admin/products/:id',
                name: 'Product',
                component: Product
            },
            {
                path: '/admin/entitlements',
                name: 'Entitlements',
                component: Entitlements
            },
            {
                path: '/admin/entitlements/:id',
                name: 'Entitlement',
                component: Entitlement
            },
            {
                // cid, service and namespace all live in the URL so the page can be
                // copied into another tab/shared and resolve to the same credentials
                path: '/:cid/admin/credentials',
                name: 'Aquacred Credentials',
                component: AquacredCredentials,
                alias: '/admin/credentials',
                meta: {
                    // drop the service/namespace selection when the client changes
                    "cidChangeRedirectRoute": "Aquacred Credentials"
                },
                beforeEnter: async (to, from, next) => {
                    // the aMDP service lists its namespaces as sandboxes
                    if (store.state.sandbox.sandboxesReady) {
                        return next();
                    }
                    await store.dispatch('sandbox/fetchSandboxes');
                    next();
                }
            },
            {
                path: '/:cid/admin/credentials/:service/:namespace/:id',
                name: 'Aquacred Credential',
                component: AquacredCredential,
                alias: '/admin/credentials/:service/:namespace/:id',
                meta: {
                    "cidChangeRedirectRoute": "Aquacred Credentials"
                }
            },
            // Credential-scoped rather than sandbox-scoped now that pail serves it, so it
            // sits with the other aquacred-backed admin pages; the credential travels in
            // the query string.
            {
                path: '/:cid/admin/file-browser',
                name: 'File Browser',
                component: FileBrowser,
                alias: '/admin/file-browser',
                meta: {
                    "cidChangeRedirectRoute": "File Browser"
                },
                children:[
                    {
                        path: '/:cid/admin/file-browser/:bucket/list',
                        name: 'File Browser List',
                        component: FolderView,
                        alias: '/admin/file-browser/:bucket/list',
                        meta: { "cidChangeRedirectRoute": "File Browser" }
                    },
                    {
                        path: '/:cid/admin/file-browser/:bucket/folder/:id',
                        name: 'File Browser Folder',
                        component: FolderView,
                        alias: '/admin/file-browser/:bucket/folder/:id',
                        meta: { "cidChangeRedirectRoute": "File Browser" }
                    },
                    {
                        path: '/:cid/admin/file-browser/:bucket/file/:id',
                        name: 'File Browser View',
                        component: FileView,
                        alias: '/admin/file-browser/:bucket/file/:id',
                        meta: { "cidChangeRedirectRoute": "File Browser" }
                    }
                ]
            },
            {
                path: '/admin/job-templates',
                name: 'Job Template Detail',
                component: JobTemplateDetails,
                children: [
                    {
                        path: '/admin/template-jobs',
                        name: 'Template Jobs',
                        component: JobTemplates
                    },
                    {
                        path: '/admin/template-jobs/:name',
                        name: 'Template Job',
                        component: JobTemplate
                    },
                    {
                        path: '/admin/job-stacks',
                        name: 'Job Stacks',
                        component: JobStacks
                    }
                    ,
                    {
                        path: '/admin/job-stacks/:name',
                        name: 'Job Stack',
                        component: JobStack
                    },
                    {
                        path: '/admin/add-job-stacks',
                        name: 'Add Job Stack',
                        component: AddJobStack
                    },
                    {
                        path: '/admin/deploy-job-stack/:name',
                        name: 'Deploy Job Stack',
                        component: DeployJobStack
                    }
                ]

            },
            {
                path: '/admin/documentations',
                name: 'Documentations',
                component: DocLinks
            },
            {
                path: '/admin/documentations/:title',
                name: 'Documentation',
                component: DocLink
            },
            {
                path: '/admin/ai-usage/agents',
                name: 'AI Usage',
                component: AiUsage,
                children: [
                    {
                        path: '/admin/ai-usage/agents',
                        name: 'AI Usage Agents',
                        component: AiUsageAgents,
                        alias: '/admin/ai-usage/agents'
                    },
                    {
                        path: '/admin/ai-usage/mcp',
                        name: 'AI Usage MCP',
                        component: AiUsageMcp,
                        alias: '/admin/ai-usage/mcp'
                    },
                ]
            },
            {
                path: '/:cid/aut/settings',
                name: 'Settings',
                component: GeneralSettings,
                alias: '/aut/settings'
            },
            {
                path: '/:cid/aut/classes',
                name: 'Classes',
                component: Classes,
                alias: '/aut/classes'
                
            },
            {
                path: '/:cid/aut/certificates',
                name: 'aUT Certificate Details',
                component: CertificateDatails,
                children: [
                    {
                        path: '/:cid/aut/certificates',
                        name: 'aUT Certificates',
                        component: Certificates
                    },
                    {
                        path: '/:cid/aut/certificates/:id',
                        name: 'aUT Certificate',
                        component: Certificate,
                        meta: {
                            "cidChangeRedirectRoute": "aUT Certificates"
                        }
                    },
                ]
            },
            // {
            //     path: '/:cid/aut/certificates',
            //     name: 'Certificates',
            //     component: Certificates,
            //     alias: '/aut/certificates'
                
            // },
            // {
            //     path: '/:cid/aut/certificates/:id',
            //     name: 'Certificate',
            //     component: Certificate,
            //     alias: '/aut/certificates/:id'
                
            // },
            {
                path: '/:cid/aut/credentials',
                name: 'aUT Credentials',
                component: AutCredentials,
                alias: '/aut/credentials'
            },
            {
                path: '/:cid/aut/tag-templates',
                name: 'Tag Template Library',
                component: TagTemplates,
                alias: '/aut/tag-templates',
                
            },
            {
                path: '/:cid/aut/tag-templates/:name',
                name: 'Tag Template',
                component: TagTemplate,
                alias: '/aut/tag-templates/:name',
                meta: {
                    "cidChangeRedirectRoute": "Tag Template Library"
                }
            },
            {
                path: '/:cid/aut/browse-tag-templates',
                name: 'Browse Tag Templates',
                component: PublicTagTemplates,
                alias: '/aut/browse-tag-templates',
            },
            {
                path: '/:cid/aut/browse-tag-templates/:name',
                name: 'Public Tag Template',
                component: PublicTagTemplate,
                alias: '/aut/browse-tag-templates/:name',
            },
            {
                path: '/:cid/aut/initiators',
                name: 'Initiators',
                component: Initiators,
                alias: '/aut/initiators'
            },
            {
                path: '/:cid/aut/initiators/:name',
                name: 'Initiator',
                component: Initiator,
                alias: '/aut/initiators/:name',
                meta: {
                    "cidChangeRedirectRoute": "Initiators"
                }
                
            },
            {
                path: '/:cid/aut/initiator-fields',
                name: 'Initiator Fields',
                component: InitiatorFields,
                alias: '/aut/initiator-fields'
            },
            {
                path: '/:cid/aut/initiator-fields/:name',
                name: 'Initiator Field',
                component: InitiatorField,
                alias: '/aut/initiator-fields/:name',
                meta: {
                    "cidChangeRedirectRoute": "Initiator Fields"
                }
            },
            {
                path: '/:cid/aut/client-initiators',
                name: 'Client Initiators',
                component: ClientInitiators,
                alias: '/aut/client-initiators'
            },
            {
                path: '/:cid/aut/client-initiators/:name',
                name: 'Client Initiator',
                component: ClientInitiator,
                alias: '/aut/client-initiators/:name',
                meta: {
                    "cidChangeRedirectRoute": "Client Initiators"
                }
            },
            {
                path: '/:cid/aut/client-initiator-fields',
                name: 'Client Initiator Fields',
                component: ClientInitiatorFields,
                alias: '/aut/client-initiator-fields'
            },
            {
                path: '/:cid/aut/client-initiator-fields/:name',
                name: 'Client Initiator Field',
                component: ClientInitiatorField,
                alias: '/aut/client-initiator-fields/:name',
                meta: {
                    "cidChangeRedirectRoute": "Client Initiator Fields"
                }
            },
            {
                path: '/:cid/aut/generate-tag',
                name: 'Generate Tag',
                component: GenerateTag,
                alias: '/aut/generate-tag'
            },
            {
                path: '/:cid/aut/configure-hosts',
                name: 'Configure Hosts',
                component: ConfigureHosts,
                alias: '/aut/configure-hosts'

            },
            {
                path: '/:cid/aut/configure-hosts/:hostName',
                name: 'Configure CNames',
                component: ConfigureCnames,
                alias: '/aut/configure-hosts/:hostName',
                meta: {
                    "cidChangeRedirectRoute": "Configure Hosts"
                }

            },
            {
                path: '/:cid/aut/reports',
                name: 'Tag Reports',
                component: AutReports,
                alias: '/aut/reports' 
            },
            {
                path: '/:cid/aut/dashboards',
                name: 'Tag Dashboards',
                component: AutDashboards,
                alias: '/aut/dashboards'
            },
            {
                path: '/:cid/aut/usage',
                name: 'Usage',
                component: autUsage,
                alias: '/aut/usage'
            },
            {
                path: '/:cid/amdp/queries',
                name: 'Named Queries',
                component: Queries,
                alias: '/amdp/queries'
            },
            {
                path: '/:cid/amdp/queries/:id',
                name: 'Named Query',
                component: Query,
                alias: '/amdp/queries/:id',
                meta: {
                    "cidChangeRedirectRoute": "Named Queries"
                }
            },
            {
                path: '/:cid/amdp/admin-queries',
                name: 'Admin Named Query',
                component: AdminQueries,
                alias: '/amdp/admin-queries'
            },
            {
                path: '/:cid/amdp/credentials',
                name: 'Credentials',
                component: Credentials,
                alias: '/amdp/credentials',
                meta: {
                    "dataForwardOnly": true
                }
            },
            {
                path: '/:cid/amdp/credentials/:id',
                name: 'Credential',
                component: Credential,
                alias: '/amdp/credentials/:id',
                meta: {
                    "cidChangeRedirectRoute": "Credentials",
                    "dataForwardOnly": true
                }
            },
            {
                path: '/:cid/amdp/ae-demo',
                name: 'AE Demo',
                component: AnalyticsEngineDemo,
                alias: '/amdp/ae-demo',
            },
            {
                path: '/:cid/amdp/usage',
                name: 'aMDP Usage',
                component: amdpUsage,
                alias: '/amdp/usage',
            },
            {
                path: '/:cid/amdp/jobs-dashboard',
                name: 'Jobs Dashboard',
                component: JobsDashboard,
                alias: '/amdp/jobs-dashboard'
            },
            //Common File preview page, have path and limit value in query string
            {
                path: '/:cid/amdp/output-parser',
                name: 'Output Parser',
                component: OutputParser,
                alias: '/amdp/output-parser'
            },
            {
                path: '/:cid/amdp/map-my-data',
                name: 'Map My Data',
                component: DataMapper,
                children: [
                    {
                        path: '/:cid/amdp/map-my-data',
                        name: 'Map My Data Streaming',
                        component: DataMapperStreaming,
                        alias: '/amdp/map-my-data'
                    },
                    {
                        path: '/:cid/amdp/map-my-data/invocations',
                        name: 'Map My Data Invocations',
                        component: DataMapperInvocations,
                        alias: '/amdp/map-my-data/invocations'
                    },
                    {
                        path: '/:cid/amdp/map-my-data/all-invocations',
                        name: 'All Map My Data Invocations',
                        component: AllMapMyDataInvocations,
                        alias: '/amdp/map-my-data/all-invocations'
                    },
                    {
                        path: '/:cid/amdp/map-my-data/all-invocations/:id',
                        name: 'Map My Data Specific Invocation',
                        component: AllMapMyDataSpecificInvocation,
                        meta: {
                            "cidChangeRedirectRoute": "All Map My Data Invocations"
                        },
                        alias: '/amdp/map-my-data/all-invocations/:id'
                    },
                ]
            },
            {
                path: '/:cid/amdp/talk-to-my-data',
                name: 'Talk 2 My Data',
                component: TalkToMyData,
                alias: '/amdp/talk-to-my-data'
            },
            {
                path: '/:cid/paice/chat',
                name: 'PAICE',
                component: PaiceChat,
                alias: '/paice/chat'
            },
            {
                path: '/:cid/paice/settings',
                name: 'PAICE Settings',
                component: PaiceSettings,
                meta: {
                    "cidChangeRedirectRoute": "PAICE Settings"
                },
                alias: '/paice/settings'
            },
            {
                path: '/:cid/amdp/:sandboxId/jobs',
                name: 'JobsTab',
                component: JobsTab,
                meta: {
                    "sandboxTypes": ["prod","prodV2"]
                },
                children: [
                    {
                        path: '/:cid/amdp/:sandboxId/jobs',
                        name: 'Jobs',
                        component: Jobs
                    },
                    {
                        path:'/:cid/amdp/:sandboxId/jobs/pipelines',
                        name: 'Pipelines',
                        component: Pipelines
                    }
                ]
            },            
            {
                path: '/:cid/amdp/:sandboxId/jobs/:jobId',
                name: 'Job Detail',
                component: JobDetail,
                meta: {
                    "sandboxTypes": ["prod","prodV2"],
                    "cidChangeRedirectRoute": "Jobs"
                },
                children: [
                    {
                        path: '/:cid/amdp/:sandboxId/jobs/:jobId/configuration',
                        name: 'Job Configuration',
                        component: Configuration,
                        alias: '/amdp/:sandboxId/jobs/:jobId/configuration'
                    }, {
                        path: '/:cid/amdp/:sandboxId/jobs/:jobId/run-history',
                        name: 'Job Run History',
                        component: RunHistory,
                        alias: '/amdp/:sandboxId/jobs/:jobId/run-history'
                    }, {
                        path: '/:cid/amdp/:sandboxId/jobs/:jobId/execution-details/:executionId',
                        name: 'Job Execution Details',
                        component: ExecutionDetails,
                        alias: '/amdp/:sandboxId/jobs/:jobId/execution-details/:executionId'
                    },  {
                        path: '/:cid/amdp/:sandboxId/jobs/:jobId/promotions',
                        name: 'Job Promotions',
                        component: SandboxJobPromotions,
                        alias: '/amdp/:sandboxId/jobs/:jobId/promotions'
                    },
                    {
                        path: '/:cid/amdp/:sandboxId/jobs/:jobId/override',
                        name: 'Job Override',
                        component: JobOverride
                    },
                    {
                        path: '/:cid/amdp/:sandboxId/jobs/:jobId/meters',
                        name: 'Job Meters',
                        component: JobMeters
                    },
                    {
                        path: '/:cid/amdp/:sandboxId/jobs/:jobId/parameters',
                        name: 'Job Parameters',
                        component: JobParameters
                    }
                ]
            },
            {
                path: '/amdp/sandbox/unit-test',
                name: 'Unit Test',
                component: UnitTest,
                alias: '/amdp/sandbox/unit-test'
            },
            {
                path: '/:cid/amdp/sandbox/unit-test/:id',
                name: 'Unit Test Execution',
                component: UnitTestExecution,
                alias: '/amdp/sandbox/unit-test/:id'
            },
            {
                path: '/:cid/amdp/sandboxes',
                name: 'Management',
                component: Management,
                alias: '/amdp/sandboxes'
            },
            {
                path: '/:cid/amdp/sandbox/users',
                name: 'Sandbox User Access',
                component: SandboxUserAccess,
            },
            {
                path: '/:cid/amdp/sandboxes/:id',
                name: 'SandboxDetail',
                component: SandboxDetail,
                alias: '/amdp/sandboxes/:id',
                meta: {
                    "cidChangeRedirectRoute": "Management"
                }
            },{
                path: '/:cid/amdp/sandbox/:sandboxId/jobs',
                name: 'Sandbox Jobs Tab',
                component: SandboxJobsTab,
                meta: {
                    "sandboxTypes": ["dev"]
                },
                children: [
                    {
                        path: '/:cid/amdp/sandbox/:sandboxId/jobs',
                        name: 'Sandbox Jobs',
                        component: SandboxJobs
                    },
                    {
                        path:'/:cid/amdp/sandbox/:sandboxId/jobs/pipelines',
                        name: 'Sandbox Pipelines',
                        component: SandboxPipelines
                    }
                ]
            },{
                path: '/:cid/amdp/sandbox/:sandboxId/promotions',
                name: 'Promotions',
                component: Promotions,
                meta: {
                    "sandboxTypes": ["prodV2"]
                }
            },{
                path:'/:cid/amdp/sandbox/:sandboxId/promotions/:promotionId',
                name: 'Promotion Detail',
                component: PromotionDetail,
                meta: {
                    "sandboxTypes": ["prodV2"],
                    "cidChangeRedirectRoute": "Promotions"
                },
                children: [
                    {
                        path:'/:cid/amdp/sandbox/:sandboxId/promotions/:promotionId/overview',
                        name: 'Promotion Overview',
                        component: PromotionOverview
                    },
                    {
                        path:'/:cid/amdp/sandbox/:sandboxId/promotions/:promotionId/run-history',
                        name: 'Promotion Run History',
                        component: PromotionRunHistory
                    },
                    {
                        path:'/:cid/amdp/sandbox/:sandboxId/promotions/:promotionId/configuration',
                        name: 'Promotion Configuration',
                        component: PromotionConfiguration
                    },
                    {
                        path:'/:cid/amdp/sandbox/:sandboxId/promotions/:promotionId/:jobId/executions/:executionId',
                        name: 'Promotion Execution Details',
                        component: ExecutionDetails
                    }
                ]
                
            },
            {
                path: '/:cid/amdp/sandbox/:sandboxId/jobs/:jobId',
                name: 'Sandbox Job Detail',
                component: SandboxJobDetail,
                meta: {
                    "sandboxTypes": ["dev"],
                    "cidChangeRedirectRoute": "Sandbox Jobs"
                    
                },
                children: [
                    {
                        path: '/:cid/amdp/sandbox/:sandboxId/jobs/:jobId/configuration',
                        name: 'Sandbox Job Configuration',
                        component: Configuration,
                        alias: '/amdp/sandbox/:sandboxId/jobs/:jobId/configuration'
                    }, {
                        path: '/:cid/amdp/sandbox/:sandboxId/jobs/:jobId/run-history',
                        name: 'Sandbox Job Run History',
                        component: RunHistory,
                        alias: '/amdp/sandbox/:sandboxId/jobs/:jobId/run-history'
                    }, {
                        path: '/:cid/amdp/sandbox/:sandboxId/jobs/:jobId/execution-details/:executionId',
                        name: 'Sandbox Job Execution Details',
                        component: ExecutionDetails
                    }, {
                        path: '/:cid/amdp/sandbox/:sandboxId/jobs/:jobId/promotions',
                        name: 'Sandbox Job Promotions',
                        component: SandboxJobPromotions
                    },
                    {
                        path: '/:cid/amdp/sandbox/:sandboxId/jobs/:jobId/override',
                        name: 'Sandbox Job Override',
                        component: JobOverride
                    },
                    {
                        path: '/:cid/amdp/sandbox/:sandboxId/jobs/:jobId/meters',
                        name: 'Sandbox Job Meters',
                        component: JobMeters
                    },
                    {
                        path: '/:cid/amdp/sandbox/:sandboxId/jobs/:jobId/parameters',
                        name: 'Sandbox Job Parameters',
                        component: JobParameters
                    }

                ]
            },
            {
                path: '/:cid/amdp/:sandboxId/credentials',
                name: 'Sandbox Credentials',
                component: SandboxCredentials,
                alias: '/amdp/:sandboxId/credentials',
                meta: {
                    "sandboxTypes": ["dev"]
                },
                beforeEnter: async (to, from, next) => {
                    // If sandboxes already loaded, proceed immediately — zero extra wait
                    if (store.state.sandbox.sandboxesReady) {
                        return next();
                    }
                    // Otherwise wait for the fetch that's already in flight (triggered at login)
                    await store.dispatch('sandbox/fetchSandboxes');
                    next();
                }
            },
            {
                path: '/:cid/amdp/:sandboxId/credentials/:id',
                name: 'Sandbox Credential',
                component: SandboxCredential,
                alias: '/amdp/:sandboxId/credentials/:id',
                meta: {
                    "sandboxTypes": ["dev"],
                    "cidChangeRedirectRoute": "Sandbox Credentials"
                },
                beforeEnter: async (to, from, next) => {
                    // If sandboxes already loaded, proceed immediately — zero extra wait
                    if (store.state.sandbox.sandboxesReady) {
                        return next();
                    }
                    // Otherwise wait for the fetch that's already in flight (triggered at login)
                    await store.dispatch('sandbox/fetchSandboxes');
                    next();
                }
            },
            /* uncomment once cid specific job template migrated to lakeview
            {
                path: '/:cid/job-templates',
                name: 'Cid Spcific Job Template Details',
                component: CidJobTemplateDetails,
                children: [
                    {
                        path: '/:cid/job-templates',
                        name: 'Cid Specific Job Templates',
                        component: CidJobTemplates
                    },
                    {
                        path: '/:cid/job-templates/:id',
                        name: 'Cid Specific Job Template',
                        component: CidJobTemplate
                    },
                ]
            }, */
            {
                path: '/:cid/amdp/flow-set',
                name: 'Configurator (beta)',
                component: Configurator,
                alias: '/amdp/flow-set',
            },
            {
                path: '/:cid/amdp/flow-set/:id',
                name: 'Configurator Details',
                component: ConfiguratorDetails,
                alias: '/amdp/flow-set/:id',
            },
            {
                path: '/:cid/aio/usage',
                name: 'aIO Usage',
                component: aioUsage,
                alias: '/aio/usage',
            },
            {
                path: '/:cid/aio/dashboards',
                name: 'aIO Dashboards',
                component: aioDashboards,
                alias: '/aio/usage',
            },
            {
                path: '/:cid/aio/:sandboxId/handler-sandbox',
                name: 'aIO Handler Sandbox',
                component: aioHandlerSandbox,
                meta: {
                    "sandboxTypes": ["dev"]
                }                
            },
            {
                path: '/:cid/aio/:sandboxId/handler-sandbox/:jobId',
                name: 'aIO Handler Detail',
                component: HandlerDetails,
                meta: {
                    "sandboxTypes": ["dev"],
                    "cidChangeRedirectRoute": "aIO Handler Sandbox"

                },
                children: [
                    {
                        path: '/:cid/aio/:sandboxId/handler-sandbox/:jobId/configuration',
                        name: 'aIO Handler Configuration',
                        component: HandlerConfiguration
                    },
                    {
                        path: '/:cid/aio/:sandboxId/handler-sandbox/:jobId/requests',
                        name: 'aIO Handler Requests',
                        component: HandlerRequests
                    }
                ]

            },
            // Audience Manager
            {
                path: '/:cid/amdp/audiences',
                name: 'Audiences',
                component: Audiences,
                alias: '/amdp/audiences',
                redirect: { name: 'Audience Dashboard' },
                children: [
                    {
                        path: '/:cid/amdp/audiences/dashboard',
                        name: 'Audience Dashboard',
                        component: Audiences,
                        alias: '/amdp/audiences/dashboard'
                    },
                    {
                        path: '/:cid/amdp/audiences/list',
                        name: 'Audience List',
                        component: Audiences,
                        alias: '/amdp/audiences/list'
                    }
                ]
            },
            {
                path: '/:cid/amdp/audiences/:name',
                name: 'Audience Detail',
                component: AudienceDetail,
                alias: '/amdp/audiences/:name',
                meta: {
                    "cidChangeRedirectRoute": "Audience List"
                }
            },
            {
                path: '/agm/dashboards',
                name: 'Graph Dashboards',
                component: agmDashboards,
            },
            {

                path: '/:cid/agm/sandbox/:sandboxId/jobs',
                name: 'IDR',
                component: IDRList,
                meta: {
                    "sandboxTypes": ["dev"]
                }
            },
            {
                path: '/:cid/agm/sandbox/:sandboxId/jobs/:jobId',
                name: 'IDR Job Detail',
                component: IDRJobDetail,
                meta: {
                    "sandboxTypes": ["dev"],
                    "cidChangeRedirectRoute": "IDRList"
                    
                },
                children: [
                    {
                        path: '/:cid/agm/sandbox/:sandboxId/jobs/:jobId/configuration',
                        name: 'IDR Job Configuration',
                        component: IDRConfiguration
                    },
                    
                ]

            },
            {
                path: '/:cid/agm/sandbox/:sandboxId/deployments',
                name: 'Job Stack Deployments List',
                component: JobStackDeploymentsList,
                alias: '/agm/sandbox/:sandboxId/deployments',
                meta: {
                    "sandboxTypes": ["dev"]
                }
            },
            {
                path: '/:cid/agm/sandbox/:sandboxId/deployments/:id',
                name: 'Job Stack Deployment Details',
                component: JobStackDeploymentsDetail,
                meta: {
                    "cidChangeRedirectRoute": "Job Stack Deployments"
                },
                children: [
                    {
                        path: '/:cid/agm/sandbox/:sandboxId/deployments/:id',
                        name: 'Job Stack Deployment Pipeline Edit',
                        component: JobStackDeploymentsDetailEdit,
                        alias: '/agm/sandbox/:sandboxId/deployments/:id'
                    },
                    {
                        path: '/:cid/agm/sandbox/:sandboxId/deployments/:id/pipeline',
                        name: 'Job Stack Deployment Details Pipeline',
                        component: JobStackDeploymentsDetailPipeline,
                        alias: '/agm/sandbox/:sandboxId/deployments/:id/pipeline'
                    },
                    {
                        path: '/:cid/agm/sandbox/:sandboxId/deployments/:id/visualize',
                        name: 'Job Stack Deployment Details Visualize',
                        component: JobStackDeploymentsDetailVisualize,
                        alias: '/agm/sandbox/:sandboxId/deployments/:id/visualize'
                    },
                ]
            },
            {
                path: '/:cid/agm/graph-report',
                name: 'Graph Report',
                component: GraphReport
                
            },
            {
                path: '/:cid/agm/graph-report-v2',
                name: 'Graph Report V2',
                component: GraphReportV2
                
            },
            {
                path: '/:cid/agm/graph-visualizer',
                name: 'Graph Visualizer',
                component: GraphVisualizer

            },
            {
                path: '/:cid/agm/graph-curation',
                name: 'Graph Curation',
                component: GraphCuration,
                meta: { cidChangeRedirectRoute: 'Graph Curation' }

            },
            {
                path: '/:cid/agm/cluster-formation',
                name: 'Cluster Formation',
                component: ClusterFormation,
                meta: { cidChangeRedirectRoute: 'Cluster Formation' }

            },
            {
                path: '/:cid/agm/graph-my-data',
                name: 'Graph My Data',
                component: GraphMyData
            },
            {
                path: 'apps/:appId',
                name: 'Client Apps',
                component: ClientApp,
                props: true
            }


        ]
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// Registered before the main guard so a cancelled leave never touches state.
// Query/hash-only changes stay on the same page and don't interrupt a stream.
// Login routes are reached by forced logout (expired session), where "Stay"
// would be meaningless.
router.beforeEach((to, from) => {
    if (to.path === from.path || ['Login', 'CidLogin'].includes(to.name)) return true
    return confirmLeaveAgentStream(store)
})

router.beforeEach((to, from, next) => {
    store.dispatch('setLoading', false)
    
    store.dispatch('dismissToast', 'route-render')

    const { $cookies } = router.app.config.globalProperties
    
     //Checking when the cache need to clear based on the module path
    if(from.path!='/' && to.path.split("/")[1] !=from.path.split("/")[1]){
        //Note: Function to clear datatable cache if other main menu items
        store.dispatch('setDatatableCache',[])
    }
    
   
    //for external forwards like helpjuice urls
    if (to.query.forwardTo) {
        store.dispatch('setForwardTo', to.query.forwardTo)
    }
    //for internal forwards like /aut/reports 
    if (to.query.path) {
        store.dispatch('setRedirectPath', to.query.path)
    }

    const proceedRoute = () => {
        if (blockedForComputeForward()) {
            return next({ name: 'Home' })
        }
        if (store.state.forwardTo) {
            let goto = store.state.forwardTo
            store.dispatch('setForwardTo', null)
            window.location = goto
        } else if (store.state.redirectPath) {
            let goto = store.state.redirectPath;
            store.dispatch('setRedirectPath', null)
            console.log(goto);
            next(goto)
        } else {
            next()
        }
    }

    const checkCidAccess = () => {
        if(to.params.cid && Array.isArray(store.state.clients) && !store.state.clients.some(client => client.cid === to.params.cid) ){
            store.dispatch('setRestrictedAccess', true)
        } else {
            store.dispatch('setRestrictedAccess', false)
        }
    }

    // Pages flagged dataForwardOnly checked here rather than in a per-route beforeEnter
    // because beforeEnter does not re-run when only the cid param changes on the same route.
    const blockedForComputeForward = () => !!to.meta?.dataForwardOnly && store.state.isComputeForward;

    const setCurrentSandbox = () => {
        if(to.params.sandboxId) {
            store.dispatch('sandbox/setCurrentSandbox', to.params.sandboxId);
        }
    }

    // 'PAICE OAuth Callback' is public because it needs no session: it runs in
    // a consent popup, relays the redirect's query parameters to the window
    // that opened it, and closes. Guarding it would send the popup to the login
    // redirect, and `code`/`state` would be lost with the query string.
    const publicRoutes = ['Login', 'CidLogin', 'Logout', 'Onboarding', 'PAICE OAuth Callback', 'Session Refresh Callback'];
    const loginRedirect = () => {
        const cid = localStorage.getItem('cidLogin');
        return cid ? { name: 'CidLogin', params: { cid } } : { name: 'Login' };
    };

    //Authentication Logic
    if (!publicRoutes.includes(to.name) && store.state.currentUser == null) {
        store.dispatch('setLoading', true)
        //check for incoming access Token through tkn parameter and redirect
        if (to.name == "Home" && to.query.tkn) {
            $cookies.set('access-token', to.query.tkn)
            next({ name: 'Home' })
        }
        //resolve incoming access token
        const accessToken = $cookies.get('access-token');
        if (accessToken) {
            store.dispatch('setAccessToken', accessToken)
        } else if (!store.state.accessToken && store.state.environment != 'test') {
            //redirect to login page
            store.dispatch('setRedirectPath', to.path)
            next(loginRedirect())
        }

        const authPromise = store.dispatch('whoAmICheck')
            .then((res) => {
                //From Who-ma-i getting Token expire time and creating new cookie variable
                $cookies.set('authExpireTime', res.data.token_expires_at, new Date(res.data.token_expires_at).toUTCString(), "/", null, null, 'Strict')
                $cookies.set('access-token', accessToken, new Date(res.data.token_expires_at).toUTCString(), "/", store.getters.accessTokenCookieDomain, null, 'Strict')
                $cookies.set('apiSpecUserRole', store.getters.userRoles.getUserRole([res.data.roles]), null, null, "aqfer.net", null, null)
            

                store.dispatch('handleUserData', res.data)
                /* 
                Logic for kicking out the user if not aqfer.com email
                $cookies.set('authExpireTime',res.data.token_expires_at,new Date(res.data.token_expires_at).toUTCString(),"/",null,null,'Strict')
                $cookies.set('access-token',accessToken,new Date(res.data.token_expires_at).toUTCString(),"/",store.state.cookieDomain,null,'Strict')
                
                const email=res.data.email
                const domain = email.substring(email.lastIndexOf("@") +1);
                if(domain == "aqfer.com"){
                    store.dispatch('handleUserData', res.data)
                }else{
                    alert("App is Beta version")
                    store.dispatch('logout')
                    next({ name: 'Login' })
                } */

                //load aUT c901 container tag once after login
                if (store.state.environment == 'prod' && window.location.hostname == 'app.aqfer.net') {
                    window.AqferData  = {
                        cdmn: store.state.tagUrl,
                        lm: 'e',
                        tt: 'tcs.dhj',
                        suu: 1,
                    };
                    !function (a) {
                        a.cls = 'portal';
                        a.aqet = 'othev';
                        a.aq_m = 1;
                        a.aqet_l1 = 'session';
                        a.dmn = 'app.aqfer.net';
                        a.pn = encodeURIComponent(to.path)
                        a.uu = store.state.currentUser.email
                    }(window.AqferData)
                    let p = window.AqferData;
                    let d = document;
                    let w = window;
                    let l = 'location';
                    var o, k = [], t = p.tt.slice(-1), x = { cdmn: 1, lm: 1, tt: 1 }, y = { cid: 1, cls: 1, dmn: 1, pubid: 1, evid: 1, aq_m: 1 };
                    p.dmn = (p.dmn || (w.top[l] === w[l] ? '' + w[l] : d.referrer).split('/')[2]).split(':')[0];
                    for (o in p) { if (y[o] || ((t != 'j' || p.aq_m) && !x[o])) { k.push(o + "=" + p[o]); } }
                    var s = d.createElement(t == 'f' ? 'img' : 'script'); s.id = s.title = 'pxscrpt';
                    s.async = s.defer = !0; s.src = '//' + p.cdmn + '/1/' + p.lm + '/' + p.tt + '?' + k.join("&");
                    d.body.appendChild(s);
                }
            })
            .catch((error) => {
                console.error(error)
                store.dispatch('setRedirectPath', to.path)
                next(loginRedirect())
            })
        //Call api only if access Token is present
        if (accessToken || store.state.environment == 'test') {
            const clientsPromise = axios
                .get(store.state.clientMgmtUrl + '/v1/cids', {
                    headers: {
                        'Authorization': `Bearer ${store.state.accessToken}`
                    }
                })
                .then(async (res) => {
                    await store.dispatch('handleClientList', {clientsData:res.data, routeParams:to.params})
                    store.dispatch('admin/fetchDocLinks');
                    if (store.state.toastNotif == true) {
                        const options = {
                            message: "Successfully logged in as " + store.state.currentUser.email + ".",
                            type: "success",
                        }
                        store.dispatch('addToast', options)
                        store.state.toastNotif = false;
                    }
                }).catch((error) => {
                    console.error(error)
                })

            // helpjuice encrypted url
            // required iframe to unlock customer-assets in documentation
            const docsPromise = store.dispatch("getHelpjuiceURL").then((helpjuiceEncUrl)=>{
                if (helpjuiceEncUrl) {
                    fetch(helpjuiceEncUrl.url, {
                        mode: "no-cors",
                        credentials: 'include',
                    }).catch(error => {
                        console.error('Docs error', error);
                    });
                }
             });
            Promise.all([authPromise, clientsPromise, docsPromise]).then(() => {
                store.dispatch('setLoading', false);
                checkCidAccess(); 
                setCurrentSandbox();               
                proceedRoute()
            });

        }
    } else if (publicRoutes.includes(to.name)) {
        next()
    } else {
        if (to.params.cid && store.state.currentClient && to.params.cid !== store.state.currentClient.cid) {
            store.dispatch('setCurrentClient', to.params.cid);
        }
        checkCidAccess();
        setCurrentSandbox();
        if (blockedForComputeForward()) {
            return next({ name: 'Home' })
        }
        next()
    }


})

router.afterEach((to, from, next) => {
    //Dynamic document title 
    let paramsStr = Object.entries(to.params).map(([k, v]) => `${k}: ${v}`).join(', ');
    document.title = (to.name)? `${to.name} -${paramsStr}- Aqfer Portal`: "Aqfer Portal";
    const excludedRoutes = ['Login', 'Logout', 'Onboarding', 'Home', 'Session Refresh Callback'];
    if (to.name && !excludedRoutes.includes(to.name)) {
        try {
            const maxRecent = 3;
            const itemLabel = to.params.name || to.params.id || to.params.jobId || '';
            const displayName = itemLabel ? `${to.name} (${itemLabel})` : to.name;

            let recentPages = JSON.parse(localStorage.getItem('recentPages') || '[]');
            recentPages = recentPages.filter(p => p.path !== to.path);
            recentPages.unshift({
                name: displayName,
                path: to.path,
                routeName: to.name,
                timestamp: Date.now()
            });

            const seen = new Set();
            recentPages = recentPages.filter(p => {
                if (seen.has(p.routeName)) return false;
                seen.add(p.routeName);
                return true;
            });

            recentPages = recentPages.slice(0, maxRecent);
            localStorage.setItem('recentPages', JSON.stringify(recentPages));
        } catch (e) {
            console.error('Error saving recent pages:', e);
        }
    }
    //aqfer c901 beacon tag implementation
    if (store.state.environment == 'prod' && window.location.hostname == 'app.aqfer.net') {
        let username = store.state.currentUser ? store.state.currentUser.email : "";
        let aqtUrl = "https://"+store.state.tagUrl+"/1/e/c.gif?aqet=pv&aq_m=1&dmn=app.aqfer.net&pn=" + encodeURIComponent(to.path)
        aqtUrl += "&uu=" + username
        // fetch(aqtUrl, {
        //     mode: "no-cors",
        //     credentials: 'include',
        // });
        let pixel = new Image();
        pixel.src = aqtUrl;
        pixel.style.display = "none";
        document.body.appendChild(pixel);
    }
})

export default router